import { TFeatureSlugs, IFeature } from '@/features/roles/store/models/features.model';
import { EScope, TRoleSlugs } from '@/features/roles/store/models/role.model';

export const advancedRoleStatus = {
  PENDING: 'pending',
  VALIDATED: 'validated',
} as const;

export type TAdvancedRoleStatus = (typeof advancedRoleStatus)[keyof typeof advancedRoleStatus];
export interface IAdvancedRole<T extends TFeatureSlugs | IFeature = TFeatureSlugs> {
  slug: TAdvancedRoleSlug;
  name?: string;
  description?: string;
  parent?: TRoleSlugs;
  scopes?: EScope[];
  features?: T[];
}
export const roleNamesValues = {
  AUTH: 'auth',
  CONFIG: 'config',
  READ_ONLY: 'Read-only',
  BASIC_EDITOR: 'Basic editor',
  USER_MANAGMENT: 'User management',
  USER_BENEFICIARY_MANAGMENT: 'User & Beneficiary management',
  TRANSFERT_ONLY: 'Transfer management only',
  ALL_RIGHTS: 'All rights editor',
  MANAGER: 'Manager',
  ADMINISTRATOR: 'Administrator',
} as const;
export const roleSlugValues = {
  AUTH: 'AUTH',
  CONFIG: 'CONFIG',
  READ_ONLY: 'READ_ONLY',
  BASIC_EDITOR: 'BASIC_EDITOR',
  USER_MANAGMENT: 'USER_MANAGMENT',
  USER_BENEFICIARY_MANAGMENT: 'USER_BENEFICIARY_MANAGMENT',
  TRANSFERT_ONLY: 'TRANSFERT_ONLY',
  ALL_RIGHTS: 'ALL_RIGHTS',
  MANAGER: 'MANAGER',
  ADMINISTRATOR: 'ADMINISTRATOR',
} as const;
export type TAdvancedRoleSlug = keyof typeof roleSlugValues;

export function isAdvancedRoleSlug(maybe: string): maybe is TAdvancedRoleSlug {
  return Object.keys(roleSlugValues).includes(maybe as TAdvancedRoleSlug);
}
export interface IAdvancedRoleMetadata {
  slug: string;
  status: TAdvancedRoleStatus;
  modifiedBy?: string;
  lastModified?: string;
}
